import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=d1c4222c&scoped=true"
import script from "./Recordings.vue?vue&type=script&lang=js"
export * from "./Recordings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c4222c",
  null
  
)

export default component.exports